// Simple module-level callback storage for order properties modal
// This avoids prop drilling and context complexity
let orderPropertiesCallback: (() => void | Promise<void>) | null = null

export const setOrderPropertiesCallback = (callback: (() => void | Promise<void>) | null) => {
  orderPropertiesCallback = callback
}

export const getOrderPropertiesCallback = () => {
  return orderPropertiesCallback
}

export const clearOrderPropertiesCallback = () => {
  orderPropertiesCallback = null
}
